import React from 'react';

const SpecialClause = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Special Clause
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Buyer and Seller acknowledge receipt of a copy of this Agreement at
          the time of signing.
        </li>
        <li>
          This Agreement may be executed in one or more counterparts, each of
          which shall be deemed to be an original and which counterparts
          together shall constitute one and the same Agreement of the Parties.
        </li>
      </ol>
    </div>
  );
};

export default SpecialClause;
